import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    IconButton,
    Avatar,
    Box,
    Button,
    styled,
} from '@mui/material';
import {
    History,
    NotificationsNone,
    Language,
    Schedule,
    Sync,
    HelpOutline
} from '@mui/icons-material';
import { COLORS } from '../../assets/colors';
// import { deepPurple } from '@mui/material/colors';
import { MEDIAS } from '../../assets/medias';
import IosShareIcon from '@mui/icons-material/IosShare';
import ReadmeGuide from '../../sharedComponents/ReadmeGuide';

const StyledToolbar = styled(Toolbar)({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    '& .MuiIconButton-root': {
        color: '#555', // Adjust the color to match your design
    }
});




const TopBar = () => {
    const [open, setOpen] = useState(false); // État pour contrôler l'ouverture du dialogue

    const handleOpen = () => setOpen(true); // Fonction pour ouvrir le dialogue
    const handleClose = () => setOpen(false); // Fonction pour fermer le dialogue
    return (
        <AppBar position="static" color="transparent" elevation={0}>
            <StyledToolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                {/* "Se connecter" button aligned to the left */}
                <Button
                    sx={{
                        p: '10px',
                        boxShadow: 'none',
                        bgcolor: COLORS.GRAY_BG, // Couleur du fond
                        borderRadius: '60px',
                        fontSize: "12px",
                        textTransform: 'capitalize',
                        fontFamily: 'Inter, Roboto !important',
                        color: COLORS.GRAY_ICONS, // Couleur du texte (blanc ici, tu peux ajuster)
                        '& .MuiButton-startIcon': {
                            color: COLORS.GRAY_ICONS, // Couleur de l'icône (blanc ici, tu peux ajuster)
                        },
                        '&:hover': {
                            bgcolor: COLORS.GRAY_HOVER, // Optionnel : changer la couleur au survol
                            opacity: 0.8, // Optionnel : ajouter un effet d'opacité au survol
                            boxShadow: 'none'
                        },
                    }}
                    variant="contained"
                    startIcon={<IosShareIcon />}
                >
                    Partager
                </Button>


                {/* Rest of the items, aligned to the right */}
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: COLORS.GRAY_AVATAR, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IconButton>
                            <History sx={{ fontSize: 22, color: COLORS.BLACK_TEXT }} />
                        </IconButton>
                    </Box>

                    <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: COLORS.GRAY_AVATAR, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IconButton>
                            <NotificationsNone sx={{ fontSize: 22, color: COLORS.BLACK_TEXT }} />
                        </IconButton>
                    </Box>

                    <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: COLORS.GRAY_AVATAR, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IconButton>
                            <Language sx={{ fontSize: 22, color: COLORS.BLACK_TEXT }} />
                        </IconButton>
                    </Box>

                    <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: COLORS.GRAY_AVATAR, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IconButton>
                            <Schedule sx={{ fontSize: 22, color: COLORS.BLACK_TEXT }} />
                        </IconButton>
                    </Box>

                    <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: COLORS.GRAY_AVATAR, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IconButton>
                            <Sync sx={{ fontSize: 22, color: COLORS.BLACK_TEXT }} />
                        </IconButton>
                    </Box>

                    <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: COLORS.GRAY_AVATAR, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IconButton onClick={handleOpen}>
                            <HelpOutline sx={{ fontSize: 22, color: COLORS.BLACK_TEXT }} />
                        </IconButton>
                    </Box>

                    <IconButton>
                        <Avatar sx={{ ml: 2, objectFit: 'cover' }} src={MEDIAS.walid_pic} />
                    </IconButton>
                </Box>

            </StyledToolbar>
            <ReadmeGuide openPoPup={open} onClose={handleClose} />
        </AppBar>
    );
};

export default TopBar;